import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../Workflow.scss'
import Checkbox from '../../../../../components/library/buttons/Checkbox';
import HrbTranslate from '../../../../../components/language/HrbTranslate';

const AdditionalDocumentRow = (props) => {
    const { formId, isCoupled, documentMap, isDisabled, singleSelectOnly, prefix } = props;

    const [primaryDisabled, setPrimaryDisabled] = useState(isDisabled);
    const [spouseDisabled, setSpouseDisabled] = useState(isDisabled);

    const handleCheck = (elementId, checked) => {
        var elId = elementId
        if (prefix) {
            elId = elementId.substring(prefix.length)
        }
        props.onChecked(elId, checked)
    }

    const updateDisabledStates = () => {
        if (isDisabled) {
            setPrimaryDisabled(true)
            setSpouseDisabled(true)
        } else if (isCoupled && singleSelectOnly) {
            var primaryChecked = Boolean(documentMap[`${formId}_P`]);
            var spouseChecked = Boolean(documentMap[`${formId}_S`]);
            setSpouseDisabled(primaryChecked)
            setPrimaryDisabled(spouseChecked);
        } else {
            setPrimaryDisabled(false);
            setSpouseDisabled(false);
        }
    }

    useEffect(() => {
        updateDisabledStates()
    }, [isDisabled, isCoupled]);

    useEffect(() => {
        updateDisabledStates();
    }, [documentMap[`${formId}_P`], documentMap[`${formId}_S`]])

    return (
        <div className='columns'>
            <div className={classnames('column is-offset-1', { 'is-4': isCoupled, 'is-10': !isCoupled })}>
                <div className="additional-document-wrapper">
                    <Checkbox textKey={`PrepareTask.Step3Form.${formId}`}
                        checked={documentMap[`${formId}_P`]}
                        onChecked={handleCheck}
                        elementId={`${prefix || ''}cb_${formId}_P`}
                        disabled={primaryDisabled}
                    />
                </div>
                {formId === 'T1032' && (
                    <div className={classnames('additional-document-info', { 'disabled': primaryDisabled })}>
                        <HrbTranslate text='PrepareTask.Step3Form.T1032Info' />
                    </div>
                )}
            </div>
            {isCoupled &&
                <div className='column is-4'>
                    <div className="additional-document-wrapper">
                        <Checkbox textKey={`PrepareTask.Step3Form.${formId}`}
                            checked={documentMap[`${formId}_S`]}
                            onChecked={handleCheck}
                            elementId={`${prefix || ''}cb_${formId}_S`}
                            disabled={spouseDisabled}
                        />
                    </div>
                    {formId === 'T1032' && (
                        <div className={classnames('additional-document-info', { 'disabled': spouseDisabled })}>
                            <HrbTranslate text='PrepareTask.Step3Form.T1032Info' />
                        </div>
                    )}
                </div>
            }
        </div>
    );
}

AdditionalDocumentRow.whyDidYouRender = false;

AdditionalDocumentRow.propTypes = {
    formId: PropTypes.string.isRequired,
    onChecked: PropTypes.func.isRequired,
    isCoupled: PropTypes.bool,
    documentMap: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool,
    singleSelectOnly: PropTypes.bool,
    prefix: PropTypes.string
}

export default AdditionalDocumentRow